import React from 'react'

import ListItem from 'lemon-campaign-ui/lib/molecules/ListItem'

export default ({ component, defaults, recursive }) => {
  if (!component.components.length) {
    return null
  }

  return <ListItem {...defaults}>{recursive(component.components)}</ListItem>
}
